import SaleStatus from './index'

export default class NoSelling implements SaleStatus {
  get isOnSale(): boolean {
    return false
  }
}
